export default __webpack_public_path__ + "static/media/tracker-icon.6e3ca665.jpg";